import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getOperators, saveBatchOperators } from '../../api/operators';
import type { Operator } from '../../types/Operator';
import { t } from '../../i18n/t';

const columnDefs: ColDef<Operator>[] = [
  {
    field: 'operatorId',
    headerName: t('operators.columns.operatorId'),
    width: 140,
    cellDataType: 'number',
    editable: (params: EditableCallbackParams<Operator>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  { field: 'operatorName', headerName: t('operators.columns.operatorName'), flex: 1, editable: true },
];

const newRowDefaults = (): Partial<Operator> => ({ operatorId: 0, operatorName: '' });

export function OperatorsPage() {
  return (
    <LopCrudPage<Operator>
      resourceCode="operators"
      titleKey="operators.pageTitle"
      idField="operatorId"
      getRows={getOperators}
      saveBatch={(added, modified, deletedIds) => saveBatchOperators(added, modified, deletedIds as number[])}
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
